import React, { Dispatch, SetStateAction } from 'react';
import { Checkbox, Grid } from '@material-ui/core';
import { Text } from 'library';

export default function SendToOthers({
    sendToOthers,
    setSendToOthers,
    providerName,
}: {
    sendToOthers: boolean;
    setSendToOthers: Dispatch<SetStateAction<boolean>>;
    providerName: string;
}) {
    return (
        <Grid item container xs={12} direction="row" justify="center" style={{ paddingTop: 10 }}>
            <Checkbox checked={sendToOthers} onChange={(e, checked) => setSendToOthers(checked)} />
            <Text variant="body1" textStyle={{ maxWidth: '80%' }}>
                If {providerName} is not available, send this job to other providers available for this time.
            </Text>
        </Grid>
    );
}
